/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Dispatch } from 'react';
import {
  Container, Inline, Radio, RadioGroup, Row,
} from '@airbus/components-react';
import { chipConstants } from '../Shared/ChipLabel/constants';
import { FIN_STATUS_MAPPER } from '../../utils/constants';
import { setFinChangesStateReducer } from '../../models/checkerDetailsModel/checkerDetailsSlice';

interface FinStatusInterface {
  statusProps: any;
  checkerDataTableState: { finChangesState?: any[] };
  CheckerFinEditModalPopupDispatcher: Dispatch<any>;
  featureToggle: boolean;
  applyAllToggleState: boolean;
  selectedFin: any[];
}

const CheckerFinEditStatusComponent = ({
  statusProps,
  checkerDataTableState,
  CheckerFinEditModalPopupDispatcher,
  featureToggle,
  applyAllToggleState,
  selectedFin,
}: FinStatusInterface) => {
  const changes = checkerDataTableState.finChangesState || [];

  // Helper for consistent identification
  const isSameFin = (item: any, current: any) => {
    if (!item || !current) return false;
    if (item.uniqueid && current.uniqueid) return item.uniqueid === current.uniqueid;
    return item.fleet_fin === current.fleet_fin
           && item.id_aircraft_registration === current.id_aircraft_registration;
  };

  const getActiveStatus = () => {
    const isThisCardSelected = selectedFin?.some((s) => isSameFin(s, statusProps));
    const myChange = changes.find((c) => isSameFin(c, statusProps));

    // Always prefer direct/manual change on this card
    if (myChange?.fin_status) {
      return myChange.fin_status;
    }

    // Apply-all mode: only cards in selection should inherit group leader value
    if (applyAllToggleState && isThisCardSelected) {
      const groupLead = changes.find((c) => selectedFin?.some((s) => isSameFin(c, s)));
      return groupLead?.fin_status ?? selectedFin?.[0]?.fin_status ?? statusProps.fin_status;
    }

    return statusProps.fin_status;
  };

  const displayStatusKey = getActiveStatus();
  const selectedStatusValue = displayStatusKey
    ? chipConstants[FIN_STATUS_MAPPER[displayStatusKey]]?.chipText
    : undefined;

  const handleStatusChangeLocal = (newTextValue: string) => {
    const targetStatusKey = (Object.keys(FIN_STATUS_MAPPER) as Array<keyof typeof FIN_STATUS_MAPPER>)
      .find((key) => chipConstants[FIN_STATUS_MAPPER[key]]?.chipText === newTextValue);

    if (!targetStatusKey) return;

    const updatedArray = [...changes];
    const existingIndex = updatedArray.findIndex((item) => isSameFin(item, statusProps));

    const newEntry = {
      ...statusProps,
      ...(existingIndex !== -1 ? updatedArray[existingIndex] : {}),
      fin_status: targetStatusKey,
    };

    if (existingIndex !== -1) {
      updatedArray[existingIndex] = newEntry;
    } else {
      updatedArray.push(newEntry);
    }

    // This updates ONLY the card you clicked, allowing it to be different from the others
    CheckerFinEditModalPopupDispatcher(setFinChangesStateReducer(updatedArray));
  };

  return (
    <Container className="fin-status-container">
      <Row className="changes-fin-list">
        <Inline spacing="5-x">
          <RadioGroup
            row
            value={selectedStatusValue}
            onChange={(_, value) => handleStatusChangeLocal(value as string)}
          >
            <Radio
              label={chipConstants[FIN_STATUS_MAPPER.M].chipText}
              value={chipConstants[FIN_STATUS_MAPPER.M].chipText}
              className="fin-status-radio fin-margin"
            />
            <Radio
              label={chipConstants[FIN_STATUS_MAPPER.TBA].chipText}
              value={chipConstants[FIN_STATUS_MAPPER.TBA].chipText}
              className="fin-status-radio"
            />
            <Radio
              label={chipConstants[FIN_STATUS_MAPPER.W].chipText}
              value={chipConstants[FIN_STATUS_MAPPER.W].chipText}
              className="fin-status-radio"
            />
            {featureToggle && (
              <Radio
                label={chipConstants[FIN_STATUS_MAPPER.not_checked].chipText}
                value={chipConstants[FIN_STATUS_MAPPER.not_checked].chipText}
                className="fin-status-radio"
              />
            )}
          </RadioGroup>
        </Inline>
      </Row>
    </Container>
  );
};

export default CheckerFinEditStatusComponent;
